import { useFrame } from '@react-three/fiber'
import { useRef } from 'react'
import * as THREE from 'three'
import { useRunState } from '@/src/game/provider/useRunState'
import { useShadowTexture } from '../../materials/shadowTexture'

const SHADOW_BASE_SCALE = 0.65
const SHADOW_OPACITY = 0.75
const SHADOW_MAX_JUMP_HEIGHT = 2.5
const SHADOW_MIN_SCALE_FACTOR = 0.015
const SHADOW_SURFACE_OFFSET = 0.01

export function CharacterShadow() {
    const meshRef = useRef<THREE.Mesh>(null)
    const materialRef = useRef<THREE.MeshBasicMaterial>(null)
    const runState = useRunState()

    const shadowTexture = useShadowTexture()

    useFrame(() => {
        if (!meshRef.current || !materialRef.current) return
        const snapshot = runState.snapshot

        meshRef.current.position.x = snapshot.laneVisualX
        meshRef.current.position.y = SHADOW_SURFACE_OFFSET
        meshRef.current.position.z = 0

        const jumpOffset = Math.max(snapshot.characterVisualPosition[1], 0)
        const normalizedHeight = Math.min(jumpOffset / SHADOW_MAX_JUMP_HEIGHT, 1)

        const scaleFactor = 1 - normalizedHeight * (1 - SHADOW_MIN_SCALE_FACTOR)
        meshRef.current.scale.setScalar(SHADOW_BASE_SCALE * scaleFactor)

        materialRef.current.opacity = SHADOW_OPACITY * (1 - normalizedHeight * 0.5)
    })

    return (
        <mesh
            ref={meshRef}
            rotation={[-Math.PI / 2, 0, 0]}
            renderOrder={1}
        >
            <planeGeometry args={[1, 1]} />
            <meshBasicMaterial
                ref={materialRef}
                color='#000000'
                alphaMap={shadowTexture}
                transparent
                depthWrite={false}
                opacity={SHADOW_OPACITY}
                side={THREE.FrontSide}
                toneMapped={false}
                polygonOffset
                polygonOffsetFactor={-1}
                polygonOffsetUnits={-1}
            />
        </mesh>
    )
}
